import {lazy, Suspense, useEffect} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import Cookies from 'js-cookie';
import {t} from 'i18next';
import {ConfigProvider} from 'antd';
import arEG from 'antd/lib/locale/ar_EG';
import enUS from 'antd/lib/locale/en_US';
import {RouteDto, ROUTES} from './models';
import {Layout, Loader} from '@/components';
import {ProtectedRoute} from './components/common';
import {useAuth} from './hooks';
import i18n from './i18n';
import {routesList} from './constants';
import './styles/main.scss';

const NotFound = lazy(() => import('./pages/not-found'));
const Login = lazy(() => import('./pages/login'));
const UnAuthorized = lazy(() => import('./pages/un-authorized'));
const ForgetPassword = lazy(() => import('./pages/forget-password'));
const ChangePassword = lazy(() => import('./pages/change-password'));

function App() {
  const user = useAuth();
  const currentLanguage = Cookies.get('i18next') || 'en';

  useEffect(() => {
    document.body.dir = currentLanguage === 'en' ? 'ltr' : 'rtl';
    document.documentElement.setAttribute('lang', currentLanguage);
    document.title = t('suplift');
  }, [currentLanguage]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#ff5d5d',
        },
        components: {
          Layout: {
            colorBgHeader: '#ffff',
          },
          Button: {
            colorBorder: '#ff5d5d',
            colorPrimary: '#ff5d5d',
          },
        },
      }}
      locale={i18n.language === 'en' ? enUS : arEG}
      direction={i18n.dir(i18n.language)}
    >
      <Suspense fallback={<Loader/>}>
        <Routes>
          <Route path={ROUTES.HOME} element={<Layout/>}>
            {/* private Routes */}
            {routesList.map((route: RouteDto) => (
              <Route
                key={route.id}
                element={
                  <ProtectedRoute
                    pathName={route.path}
                    component={route.component}
                  />
                }
              >
                <Route path={route.path} element={route.component}/>
              </Route>
            ))}
            {/* public Routes */}
            <Route
              path={ROUTES.NOT_FOUND}
              element={
                user?.token ? <NotFound/> : <Navigate to={ROUTES.LOGIN}/>
              }
            />
            <Route
              path={ROUTES.UNAUTHORIZED}
              element={
                user?.token ? <UnAuthorized/> : <Navigate to={ROUTES.LOGIN}/>
              }
            />
          </Route>
          <Route path={ROUTES.LOGIN} element={<Login/>}/>
          <Route path={ROUTES.FORGET_PASSWORD} element={<ForgetPassword/>}/>
          <Route path={ROUTES.CHANGE_PASSWORD} element={<ChangePassword/>}/>
        </Routes>
      </Suspense>
    </ConfigProvider>
  );
}

export default App;
